// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__QLTT8","icon":"SortAdornment_icon__3lArH","up":"SortAdornment_up__3Lj-X","down":"SortAdornment_down__1Wqk4","active":"SortAdornment_active__2NxW-"};